import { IKnob } from '../IComponents.js';

/**
 * BasicKnob - HTML range input styled as a knob
 */
export class BasicKnob extends IKnob {
    constructor(container, options) {
        super(container, options);
        this.value = options.value ?? options.min ?? 0;
        this._create();
    }

    _create() {
        const { min = 0, max = 100, value, label, step, unit = '' } = this.options;

        this.element = document.createElement('div');
        this.element.className = 'knob-group';

        // Input range
        this.input = document.createElement('input');
        this.input.type = 'range';
        this.input.min = min;
        this.input.max = max;
        this.input.value = value ?? min;
        if (step) this.input.step = step;

        // Label
        if (label) {
            this.labelEl = document.createElement('span');
            this.labelEl.className = 'knob-label';
            this.labelEl.textContent = label;
        }

        // Value display
        this.valueEl = document.createElement('span');
        this.valueEl.className = 'knob-value';
        this._updateValueDisplay();

        // Event listener
        this.input.addEventListener('input', (e) => {
            this.value = parseFloat(e.target.value);
            this._updateValueDisplay();
            this._emitChange(this.value);
        });

        // Assemble
        this.element.appendChild(this.input);
        if (this.labelEl) this.element.appendChild(this.labelEl);
        this.element.appendChild(this.valueEl);

        this.container.appendChild(this.element);
    }

    _updateValueDisplay() {
        const { unit = '', decimals } = this.options;
        let displayValue = this.value;

        if (typeof decimals === 'number') {
            displayValue = this.value.toFixed(decimals);
        } else if (unit === '%') {
            displayValue = Math.round(this.value * 100);
        } else if (unit === 'Hz' && this.value >= 1000) {
            displayValue = (this.value / 1000).toFixed(1) + 'k';
        }

        this.valueEl.textContent = displayValue + (unit && unit !== '%' ? ' ' + unit : unit);
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = value;
        this.input.value = value;
        this._updateValueDisplay();
    }
}
